import { makeStyles } from 'tss-react/mui'

import { hubloTheme } from '@front/theme'

export const useAppSnackbarProviderStyles = makeStyles()(() => ({
  success: {
    backgroundColor: hubloTheme.palette.chrysopraseLighter.main,
    color: hubloTheme.palette.chrysopraseDarker.main,
  },
  error: {
    backgroundColor: hubloTheme.palette.andesineLighter.main,
    color: hubloTheme.palette.andesineDarker.main,
  },
  info: {
    backgroundColor: hubloTheme.palette.sodaliteLighter.main,
    color: hubloTheme.palette.sodaliteDarker.main,
  },
  warning: {
    backgroundColor: '#FFEFD8',
    color: '#C17300',
  },
  variantRoot: {
    boxShadow: 'none',
    borderRadius: 8,
    fontWeight: 700,
    display: 'flex',
    justifyContent: 'space-between',
    flexWrap: 'nowrap',
    padding: hubloTheme.spacing(1, 2),
  },
  icon: {
    marginRight: hubloTheme.spacing(2),
  },
}))
